<template>
  <router-view></router-view>
</template>

<script>
export default {
	name: 'Objetos',
	title: 'Repositório - Objetos'
}
</script>

<style scoped>
</style>
